import React, {useState, useEffect, useContext} from 'react'
import { FirebaseContext } from '../../Services/firebase'

import { TextField, Autocomplete } from '@mui/material';
import DisplayMenus from './DisplayMenus';
import { getCustomerList } from '../../Utils/getCustomerList';


export default function CustomerChoice(props) {

    const firebase = useContext(FirebaseContext)

    const [Customers, setCustomers] = useState([]);
    const [value, setValue] = useState('clients');
    const [inputValue, setInputValue] = React.useState('');

    useEffect(() => {
            getCustomerList(firebase, props.UserSession.uid, setCustomers)
        }, [firebase, props.UserSession.uid])

    return (
        <div>
            <div style={{display: "flex", flexDirection: "row", marginBottom: "1vh"}}>
                <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={Customers}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="clients" />}
                />
            </div>
            <DisplayMenus UserSession={props.UserSession} Customer={value}/>
        </div>
    )
}